"use strict";

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .feature-modal-", " .ant-modal-close { right: 15px !important; }\n  .feature-modal-", " .ant-modal-close-x { width: auto !important; }\n  .feature-modal-", " .ant-modal-content {\n    background: ", ";\n  }\n  .feature-modal-", " .ant-modal-header {\n    background: transparent;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var modal_1 = __importDefault(require("antd/es/modal"));

var react_1 = __importStar(require("react"));

var styled_components_1 = require("styled-components");

var Block_1 = require("./Block");

var Overlay_1 = require("./Overlay");

var Typography_1 = require("./Typography");

var styledTypes_1 = require("./styledTypes");

var ModalGlobalStyle = (0, styled_components_1.createGlobalStyle)(_templateObject(), function (props) {
  return props.id;
}, function (props) {
  return props.id;
}, function (props) {
  return props.id;
}, function (props) {
  return props.theme[props.alternateBackground ? '@gray-1' : '@gray-0'];
}, function (props) {
  return props.id;
});

var Modal = function Modal(_a) {
  var title = _a.title,
      lightMask = _a.lightMask,
      alternateBackground = _a.alternateBackground,
      customTitle = _a.customTitle,
      modalRef = _a.modalRef,
      topRightActions = _a.topRightActions,
      props = __rest(_a, ["title", "lightMask", "alternateBackground", "customTitle", "modalRef", "topRightActions"]);

  var theme = (0, react_1.useContext)(styledTypes_1.ThemeContext);

  var _react_1$default$useS = react_1.default.useState(Math.floor(Math.random() * 10000).toString()),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 1),
      id = _react_1$default$useS2[0];

  var style = lightMask ? Overlay_1.LightOverlayStyle : Overlay_1.DarkOverlayStyle;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ModalGlobalStyle, {
    id: id,
    alternateBackground: alternateBackground
  }), react_1.default.createElement(modal_1.default, Object.assign({
    footer: null,
    maskStyle: style(theme),
    closeIcon: react_1.default.createElement(Block_1.HSpaced, {
      align: 'center',
      style: {
        marginTop: theme['@size-xs']
      }
    }, topRightActions, react_1.default.createElement(Typography_1.Body, {
      color: '@primary-color',
      weight: Typography_1.FontWeight.Normal,
      ref: function ref(el) {
        if (el && modalRef) {
          modalRef.current = el.closest('.feature-modal');
        }
      }
    }, "Close"))
  }, props, {
    className: "feature-modal feature-modal-".concat(id, " ").concat(props.className),
    bodyStyle: Object.assign(Object.assign({}, props.bodyStyle), {
      paddingTop: 0
    }),
    title: customTitle ? customTitle : title ? react_1.default.createElement(Typography_1.H2, {
      isBlock: false,
      style: {
        lineHeight: 1,
        marginTop: theme['@size-xs']
      }
    }, title) : undefined
  })));
};

exports.Modal = Modal;